
import { Component, ViewEncapsulation } from '@angular/core';
import { PreviewService } from './preview.service';

import * as $ from 'jquery';

@Component({
  selector: 'app-preview-service',
  encapsulation: ViewEncapsulation.None,
  templateUrl: './preview.service.pug',
  styleUrls: ['./preview.service.sass'],
})
export class PreviewComponent {

  get hasData(): boolean {
    return this.previewService && this.previewService.previewModel && this.previewService.previewModel.Data;
  }

  get data(): any { return this.previewService.previewModel; }

  get modalY(): number { return this.previewService.previewModel.position.Y; }
  get modalX(): number { return this.previewService.previewModel.position.X; }

  constructor(public previewService: PreviewService) { }

  showModal() {
    $('#previewModal').modal('show');
  }

  hideModal() {
    $('#previewModal').modal('hide');
  }
}



// WEBPACK FOOTER //
// ./src/app/common/preview.service/preview.service.component.ts